import { Directive, effect, ElementRef, Renderer2 } from '@angular/core';
import { OrganizationService } from '../services/organization.service';
import { PermissionService } from '../services/permission.service';

@Directive({
  selector: '[disableIfNoGroupPermission]',
  standalone: true
})
export class DisableIfNoGroupPermissionDirective {

  constructor(
    private organizationService: OrganizationService,
    private permissionService: PermissionService,
    private renderer: Renderer2,
    private elementRef: ElementRef)   
  { 
    const nativeElement = this.elementRef.nativeElement;
    if (!(nativeElement instanceof HTMLElement)) {
      console.warn(
        'disableIfNoGroupPermission directive must be applied to an HTML element, not a component or non-element node.',
        nativeElement
      );
      return;
    }


    effect(() => {

      const organizationId = this.organizationService.currentOrganizationId;
      const hasPermission =  organizationId && this.permissionService.hasElevatedPermission(organizationId);

      if (hasPermission) {
        this.renderer.removeAttribute(this.elementRef.nativeElement, 'disabled');
        this.renderer.removeClass(this.elementRef.nativeElement, 'disabled');
      } else {
        this.renderer.setAttribute(this.elementRef.nativeElement, 'disabled', 'true');
        this.renderer.addClass(this.elementRef.nativeElement, 'disabled');
      }
    });
  }

}
